var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIconReferral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.8601 2.05957H23.1301C11.4934 2.05957 2.06006 11.4929 2.06006 23.1296V96.8596C2.06006 108.496 11.4934 117.93 23.1301 117.93H96.8601C108.497 117.93 117.93 108.496 117.93 96.8596V23.1296C117.93 11.4929 108.497 2.05957 96.8601 2.05957Z",
    fill: "#FB4D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.53 32.5501C88.52 32.2901 88.47 32.0401 88.38 31.8001C88.35 31.7101 88.32 31.6201 88.28 31.5301C88.14 31.2301 87.97 30.9401 87.72 30.6901C87.47 30.4401 87.19 30.2701 86.89 30.1401C86.8 30.1001 86.71 30.0701 86.61 30.0301C86.37 29.9501 86.13 29.9001 85.88 29.8901C85.8 29.8901 85.72 29.8701 85.64 29.8701C85.35 29.8701 85.05 29.9201 84.77 30.0201L27.73 49.9801C26.62 50.3701 25.87 51.3901 25.82 52.5601C25.77 53.7301 26.44 54.8101 27.51 55.2801L52.18 66.2401L63.14 90.9101C63.6 91.9401 64.62 92.6001 65.75 92.6001C65.79 92.6001 65.83 92.6001 65.87 92.6001C67.04 92.5501 68.06 91.8001 68.45 90.6901L88.41 33.6501C88.51 33.3601 88.55 33.0701 88.56 32.7701C88.56 32.7001 88.55 32.6201 88.54 32.5501H88.53ZM74.86 39.5301L53.71 60.6801L36.4 52.9901L74.86 39.5301V39.5301ZM65.43 82.0201L57.74 64.7101L78.89 43.5601L65.43 82.0201Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconReferral);
export default __webpack_public_path__ + "static/media/media-icon-referral.8988c55132328bcda609c513a10951a6.svg";
export { ForwardRef as ReactComponent };